import React, {useCallback, useState} from 'react';
import {
  navigateVanLoadActions,
  useNavigateVanLoadContext,
} from '@buncha/batchDetails/hooks/NavigateVanLoad';

import {Box} from '@buncha/components/core/view';
import {CustomFlatList} from '@buncha/components/core/list';
import If from '@buncha/components/conditional/If';
import OrderListCell from './OrderListCell';
import {OrderListStyle} from './styles';
import {OrdersForShopper} from '@buncha/batchDetails/types';
import UsedBagBottomSheet from '../UsedBag/UsedBagBottomSheet';
import {useIsMeijerStore} from '@buncha/home/hooks/home';
import {useRoute} from '@react-navigation/native';

interface OrderListProps {
  orders: OrdersForShopper[];
}

const OrderList = (props: OrderListProps) => {
  const {state, dispatch} = useNavigateVanLoadContext();
  const [open, setOpen] = useState(false);
  const [bagCountDetails, setBagCountDetails] = useState<OrdersForShopper>();
  const route = useRoute();
  const routeParams: {runId?: number} | undefined = route.params;
  const runId = routeParams?.runId || 0;
  const storeId = state.run?.masterRun?.store?.id;
  const isB2BStore = useIsMeijerStore(storeId);

  const checkBoxHandler = useCallback(
    (orderId: number, hasChecked: boolean) => {
      if (dispatch)
        dispatch(
          navigateVanLoadActions.setBagCountUpdateStatus({
            orderId: orderId,
            isBagCountUpdated: hasChecked,
          }),
        );
    },
    [dispatch],
  );

  const toggleBottomSheet = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const renderItem = useCallback(
    ({item}: {item: OrdersForShopper; index: number}) => {
      return (
        <OrderListCell
          order={item}
          checkBoxHandler={checkBoxHandler}
          toggleBottomSheet={toggleBottomSheet}
          setBagCountDetails={setBagCountDetails}
        />
      );
    },
    [checkBoxHandler, toggleBottomSheet],
  );

  return (
    <Box style={OrderListStyle.flexBox}>
      <CustomFlatList
        data={props?.orders}
        renderItem={renderItem}
        style={OrderListStyle.mainContainer}
      />
      <If condition={open}>
        <UsedBagBottomSheet
          open={open || false}
          onClose={toggleBottomSheet}
          buyerName={`${bagCountDetails?.buyer?.firstName} ${bagCountDetails?.buyer?.lastName}`}
          usedBag={bagCountDetails?.bagsUsed || 0}
          orderId={bagCountDetails?.id || 0}
          runId={runId}
          isB2BStore={isB2BStore}
        />
      </If>
    </Box>
  );
};

export default React.memo(OrderList);
